import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is the range of Janvahan electric bikes?",
      answer: "Our electric bikes offer a range between 80-120 km on a single full charge, depending on the model and riding conditions."
    },
    {
      question: "How long does it take to fully charge?",
      answer: "Standard charging takes 3-4 hours, while fast charging can charge up to 80% in just 2 hours."
    },
    {
      question: "What is the warranty period?",
      answer: "We offer 3 years or 50,000 km vehicle warranty, and 5 years battery warranty."
    },
    {
      question: "Where can I get my bike serviced?",
      answer: "We have authorized service centers across all major cities. You can find the nearest center on our website."
    },
    {
      question: "What financing options are available?",
      answer: "We offer easy EMI options with leading banks and NBFCs with interest rates starting from 7.99%."
    },
    {
      question: "Can I take a test ride?",
      answer: "Yes, you can schedule a test ride through our website or visit any of our dealerships."
    },
    {
      question: "Is there a home charging solution?",
      answer: "Yes, we provide a portable charger with every bike that can be plugged into any standard 15A socket."
    },
    {
      question: "What is the top speed?",
      answer: "Our bikes have a top speed ranging from 75-100 km/h depending on the model."
    },
    {
      question: "How much does maintenance cost?",
      answer: "Maintenance costs are significantly lower than traditional petrol bikes. Annual service costs approximately ₹2,000-3,000."
    },
    {
      question: "Do I need a special license for electric bikes?",
      answer: "No, a regular driving license is sufficient for riding electric bikes."
    }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-bold mb-8 text-center">Frequently Asked Questions</h1>
      <p className="text-xl text-gray-600 text-center mb-12">
        Find answers to common questions about Janvahan electric bikes
      </p>
      
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full text-left px-6 py-4 flex justify-between items-center hover:bg-gray-50 transition"
            >
              <span className="font-semibold text-lg">{faq.question}</span>
              <span className="text-2xl text-red-600">{openIndex === index ? '−' : '+'}</span>
            </button>
            {openIndex === index && (
              <div className="px-6 py-4 bg-gray-50 border-t">
                <p className="text-gray-700">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="mt-12 bg-gradient-to-r from-red-600 to-red-800 text-white rounded-lg p-8 text-center">
        <h3 className="text-2xl font-bold mb-2">Still have questions?</h3>
        <p className="mb-4">Our support team is ready to help you</p>
        <div className="space-x-4">
          <a href="/contact" className="inline-block bg-white text-red-600 px-6 py-2 rounded-lg font-semibold hover:bg-gray-100 transition">
            Contact Us
          </a>
          <a href="/support" className="inline-block border-2 border-white text-white px-6 py-2 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition">
            Support Center
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;